export const ActionTypes = {
  contactPhoneChange: 'CONTACT_PHONE_CHANGE',
  contactCancel: 'CONTACT_CANCEL',
  contactCompensation: 'CONTACT_COMPENSATION',
  clearState: 'CLEAR_STATE',
} as const
